export default __webpack_public_path__ + "static/media/item9.ec763f04.png";